/* PATCH 41 — formulaire Tally intégré (pages de devis).
   Le script de Tally n’est chargé que lorsque le formulaire approche de l’écran. Il ajuste la hauteur
   de l’iframe à son contenu. S’il ne se charge pas, l’iframe s’affiche quand même, à hauteur fixe,
   et un lien permet d’ouvrir le formulaire dans un nouvel onglet. */
(() => {
  'use strict';
  const p41t = (k, f) => { const s = window.PATCH41_STRINGS; return (s && s[k]) || f; };
  const frames = Array.from(document.querySelectorAll('iframe[data-tally-src]'));
  if (!frames.length) return;
  let requested = false;

  const showStatic = () => frames.forEach(frame => {
    if (!frame.getAttribute('src')) frame.setAttribute('src', frame.dataset.tallySrc);
    const box = frame.closest('[data-tally-embed]');
    if (box) box.classList.add('is-static');
  });

  const load = () => {
    if (requested) return;
    requested = true;
    if (window.Tally && typeof window.Tally.loadEmbeds === 'function') { window.Tally.loadEmbeds(); return; }
    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    script.onload = () => {
      if (window.Tally && typeof window.Tally.loadEmbeds === 'function') window.Tally.loadEmbeds();
      else showStatic();
    };
    script.onerror = showStatic;
    document.head.appendChild(script);
    setTimeout(() => { if (!window.Tally) showStatic(); }, 10000);
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) { io.disconnect(); load(); }
    }, { rootMargin: '800px 0px' });
    frames.forEach(frame => io.observe(frame));
  } else load();

  /* Formulaire affiché : le lien de secours devient inutile. Après l’envoi : une coche apparaît
     au-dessus du message de remerciement de Tally, l’envoi est annoncé aux lecteurs d’écran, et le
     haut du formulaire revient à l’écran (la page de remerciement est plus courte). */
  window.addEventListener('message', e => {
    if (e.origin !== 'https://tally.so' || typeof e.data !== 'string') return;
    const frame = frames.find(f => f.contentWindow === e.source) || frames[0];
    const box = frame.closest('[data-tally-embed]');
    if (!box) return;
    if (e.data.indexOf('Tally.FormLoaded') !== -1) box.classList.add('is-loaded');
    if (e.data.indexOf('Tally.FormSubmitted') !== -1 && !box.classList.contains('is-submitted')) {
      box.classList.add('is-submitted', 'is-loaded');
      const done = box.querySelector('[data-tally-done]');
      if (done) done.hidden = false;
      const status = box.querySelector('[data-tally-status]');
      if (status) status.textContent = p41t('tally_sent', 'Demande envoyée.');
      const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
    }
  });
})();
